import React from 'react'
import { Descriptions } from 'antd'

import IntlMessages from '../../util/IntlMessages'
import { IBillingInfo } from '../../types/company'
import upperCase from 'lodash/upperCase'

interface IBillingInformation {
  billingInfo: IBillingInfo
}

const BillingInformation = ({
  billingInfo,
}: IBillingInformation): React.ReactElement => {
  const { billingEmails, billingName, address } = billingInfo

  return (
    <Descriptions className="info-box" layout='horizontal' column={1} bordered>
      <Descriptions.Item label={<IntlMessages id="general.companyName" />}>
        {billingName}
      </Descriptions.Item>
    
      <Descriptions.Item label={<IntlMessages id="components.billing.email" />}>
        {billingEmails.join(', ')}
      </Descriptions.Item>
    
      <Descriptions.Item label={<IntlMessages id="components.billingInfo.address" />}>
        {address.address}
        {address.addressLine2 &&
          <>
            <br />
            {address.addressLine2}
          </>
        }
        <br />
        {address.city}, {address.country}{address.state ? (', ' + upperCase(address.state)) : ''}
      </Descriptions.Item>
    </Descriptions>
  )
}

export default BillingInformation
